import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { removeUnmanagedMetaTags } from '../utils/metaTagCleanup';
import { PRIVATE_ROUTE_PREFIXES } from '../_config';

const RouteMeta: React.FC = () => {
    const { pathname } = useLocation();
    const isPrivate = PRIVATE_ROUTE_PREFIXES.some(
        pre => pathname === pre || pathname.startsWith(pre + '/')
    );

    useEffect(() => {
        removeUnmanagedMetaTags(['meta[name="robots"]', 'meta[name="googlebot"]']);
    }, []);

    return (
        // <Helmet>
        <>
            <meta name="robots" content={isPrivate ? 'noindex, follow' : 'index, follow'} />
            <meta name="googlebot" content={isPrivate ? 'noindex, follow' : 'index, follow'} />
        </>
        // </Helmet>
    );
};

export default RouteMeta;
